/**
 * Cookie に値をセットします。valが空文字の場合、Cookieを削除します。
 *
 * @param {string} key - セットするCookieのキー。
 * @param {string} val - セットするCookieの値。空文字の場合、Cookieを削除します。
 * @param {number} [days] - Cookieの有効期間（日数）。指定しない場合、セッションCookieとして設定します。
 */
export function setCookie(key, val, days) {
    if (val === '') {
        // valが空文字の場合、Cookieを削除
        const expires = new Date(0); // 過去の日時
        document.cookie = `${encodeURIComponent(key)}=; expires=${expires.toUTCString()}${getSecurityAttributes()}`;
        return;
    }

    let cookie = `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    if (days != null) {
        const expires = new Date();
        expires.setDate(expires.getDate() + days);
        cookie += `;expires=${expires.toUTCString()}`;
    }
    document.cookie = cookie + getSecurityAttributes();
}

/**
 * Cookie に付与するセキュリティ属性を返します。
 *
 * HttpOnly は Set-Cookie ヘッダ専用の属性で、document.cookie から指定するとブラウザが
 * Cookie 自体を破棄する（RFC 6265 5.3 step 10）ため、ここでは付与できません。
 *
 * @returns {string} Cookie に連結する属性文字列
 */
function getSecurityAttributes() {
    // Secure は HTTPS でのみ有効。HTTP の管理画面で付与すると Cookie が保存されず機能が壊れる
    const secure = location.protocol === 'https:' ? ';Secure' : '';
    return `;SameSite=Lax${secure}`;
}
